import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { isBrowser } from "../../../context/ApolloContext"
import { useLocation } from "@reach/router"
const $ = isBrowser ? require("jquery") : {}

const BlackFridayGbpStickyBannerWrapper = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  position: relative;
  background: ${props => props.theme.saleColor.bgColor};
  // color: ${props => props.theme.saleColor.textColor};
  color: #fddeb0;
  overflow: hidden;
`

const Container = styled.div`
  width: 100%;
  margin: 0px auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px 20px;

  @media (max-width: 450px) {
    padding: 5px 10px;
  }
`

const TextWrapper = styled.div`
  width: 100%;
  margin: 0px auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`

const LinkBox = styled(Link)`
  width: 100%;
  position: absolute;
  height: 100%;
  z-index: 1;
`

const LinkButtonTitle = styled.span`
  display: none;
`

const Text = styled.div`
  font-size: 18px;
  line-height: 30px;
  font-family: "Museo";
  font-weight: 500;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  cursor: pointer;

  @media (max-width: 767px) {
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (max-width: 550px) {
    font-size: 14px;
  }
`

const BlackFridayLogo = styled.img`
  width: 100%;
  max-width: 150px;
  margin: 0px;
  object-fit: contain;
`

const BlackFridayText = styled.div`
  font-size: 32px;
  line-height: 1;
  color: #d7edf6;
  font-family: "BebasNeueBold";
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 600px) {
    font-size: 28px;
  }

  @media (max-width: 380px) {
    font-size: 24px;
  }
`

const FirstText = styled.div`
  font-size: 28px;
  line-height: 1.2;
  font-family: "BebasNeueBold";
  font-weight: bold;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  @media (max-width: 767px) {
    flex-basis: ${({ flexBasis }) => (flexBasis ? "100%" : "auto")};
    justify-content: center;
  }

  @media (max-width: 450px) {
    font-size: 22px;
  }

  @media (max-width: 360px) {
    font-size: 20px;
  }
`

const SecondText = styled.div`
  font-size: 14px;
  line-height: 1.1;
  display: flex;
  font-family: "Museo";
  font-weight: 500;
  align-items: center;
  margin-left: 10px;

  > span {
    font-size: 30px;
    font-family: "BebasNeueBold";
    font-weight: bold;
    margin-right: 8px;
    line-height: 1;

    @media (max-width: 450px) {
      font-size: 26px;
      margin-right: 5px;
    }

    @media (max-width: 380px) {
      font-size: 22px;
    }
  }

  div {
    text-align: left;

    span {
      display: block;
    }
  }

  strong {
    font-weight: 700;
  }

  @media (max-width: 850px) {
    margin-left: 15px;
  }

  @media (max-width: 767px) {
    margin-left: 0px;
  }

  @media (max-width: 450px) {
    font-size: 13px;
  }

  @media (max-width: 380px) {
    font-size: 12px;
  }
`

const ThirdText = styled.div`
  font-size: 14px;
  line-height: 1.1;
  display: flex;
  font-family: "Museo";
  font-weight: 500;
  align-items: center;
  margin-left: 20px;

  > span {
    font-size: 30px;
    font-family: "BebasNeueBold";
    font-weight: bold;
    margin-right: 8px;
    line-height: 1;

    @media (max-width: 450px) {
      font-size: 26px;
      margin-right: 5px;
    }

    @media (max-width: 380px) {
      font-size: 22px;
    }
  }

  div {
    text-align: left;

    span {
      display: block;
    }
  }

  strong {
    font-weight: 700;
  }

  @media (max-width: 850px) {
    margin-left: 15px;
  }

  @media (max-width: 450px) {
    font-size: 13px;
    margin-left: 10px;
  }

  @media (max-width: 380px) {
    font-size: 12px;
    margin-left: 7px;
  }
`

const BlackFridayGbpStickyBanner = ({ intl }) => {
  const [activeFlag, setactiveFlag] = useState(true)
  const { pathname } = useLocation()

  let ButtonHide = false

  let regex = /(lyneup|lynefit|lynehome|loop)/
  if (isBrowser) {
    ButtonHide = regex.test(window.location.pathname)
  }

  const BottomBarActive = () => {
    function isOnScreen(elem) {
      // if the element doesn't exist, abort
      if (elem.length == 0) {
        return
      }
      var $window = $(window)
      var viewport_top = $window.scrollTop()
      var viewport_height = $window.height()
      var viewport_bottom = viewport_top + viewport_height
      var $elem = $(elem)
      var top = $elem.offset().top
      var height = $elem.height()
      var bottom = top + height

      return (
        (top >= viewport_top && top < viewport_bottom) ||
        (bottom > viewport_top && bottom <= viewport_bottom) ||
        (height > viewport_height &&
          top <= viewport_top &&
          bottom >= viewport_bottom)
      )
    }
    $(window).resize(() => {
      var w = window.outerWidth
      if (w > 600) {
        if (isOnScreen($(".HomeVideoBanner"))) {
          setactiveFlag(false)
        } else {
          setactiveFlag(true)
        }
        window.addEventListener("scroll", function (e) {
          if (isOnScreen($(".HomeVideoBanner"))) {
            setactiveFlag(false)
          } else {
            setactiveFlag(true)
          }
        })
      }
    })

    $(document).ready(function () {
      var w = window.outerWidth
      if (w > 600) {
        if (isOnScreen($(".HomeVideoBanner"))) {
          setactiveFlag(false)
        } else {
          setactiveFlag(true)
        }
        window.addEventListener("scroll", function (e) {
          if (isOnScreen($(".HomeVideoBanner"))) {
            setactiveFlag(false)
          } else {
            setactiveFlag(true)
          }
        })
      }
    })
  }

  useEffect(() => {
    isBrowser && BottomBarActive()
  }, [pathname])

  return (
    activeFlag && (
      <BlackFridayGbpStickyBannerWrapper className="LyneHomeStickyBanner">
        <Container>
          <TextWrapper>
            {ButtonHide && (
              <LinkBox to="/shop/lyneup-test/">
                <LinkButtonTitle>Shop Now</LinkButtonTitle>
              </LinkBox>
            )}
            <Text>
              <FirstText flexBasis="100%">
                {/* <BlackFridayLogo src="https://static.percko.com/uploads/ba96bf00-bf22-41ff-a5e0-ad5e3ed5ba58.gif" /> */}
                <BlackFridayText
                  dangerouslySetInnerHTML={{
                    __html: "Black Friday",
                  }}
                />
              </FirstText>
              <SecondText>
                <span>£15 off</span>
                <div>
                  <strong>one</strong> PERCKO <span>vest</span>
                </div>
              </SecondText>
              <ThirdText>
                <span>£50 off</span>
                <div>
                  <strong>two</strong> PERCKO <span>vests</span>
                </div>
              </ThirdText>
            </Text>
          </TextWrapper>
        </Container>
      </BlackFridayGbpStickyBannerWrapper>
    )
  )
}

export default injectIntl(BlackFridayGbpStickyBanner)
